import {
  getLoadedPhosphorIconSvg,
  isPhosphorIconName,
  loadPhosphorIconSvg,
} from '@blocksuite/affine-shared/utils';
import * as allIcons from '@blocksuite/icons/rc';
import { type SVGProps, useEffect, useState } from 'react';

const PhosphorIconRenderer = ({
  name,
  ...props
}: {
  name: string;
} & SVGProps<SVGSVGElement>) => {
  const [svg, setSvg] = useState(() => getLoadedPhosphorIconSvg(name));

  useEffect(() => {
    let cancelled = false;
    setSvg(getLoadedPhosphorIconSvg(name));
    loadPhosphorIconSvg(name)
      .then(loaded => !cancelled && setSvg(loaded))
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [name]);

  if (!svg) {
    return null;
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      width="1em"
      height="1em"
      fill="currentColor"
      {...props}
      // Markup comes from the bundled Phosphor data, never from user input.
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
};

export const AffineIconRenderer = ({
  name,
  ...props
}: {
  name: string;
} & SVGProps<SVGSVGElement>) => {
  if (isPhosphorIconName(name)) {
    return <PhosphorIconRenderer name={name} {...props} />;
  }

  const Icon = allIcons[
    `${name}Icon` as keyof typeof allIcons
  ] as React.ComponentType<React.SVGProps<SVGSVGElement>>;

  if (!Icon) {
    return null;
  }

  return <Icon {...props} />;
};
